export enum ResponseTypeEnum {
    Blob = 'blob',
    ArrayBuffer = 'arraybuffer'
}
